import { z } from 'zod';

// 应用名称校验（3-32字符，支持中英文、数字、下划线、连字符）
export const appNameSchema = z
  .string()
  .min(3, '应用名称至少3个字符')
  .max(32, '应用名称最多32个字符');

// 应用描述校验
export const appDescriptionSchema = z
  .string()
  .max(500, '应用描述最多500个字符')
  .optional()
  .default('');

// 运营模式校验
export const operationModeSchema = z.union([z.literal(1), z.literal(2)]);

// 软件公告校验
export const announcementSchema = z.string().max(1024, '软件公告最多1024个字符').optional();

// 基础数据校验（必须为合法 JSON）
export const baseDataSchema = z
  .string()
  .max(1024, '基础数据最多1024个字符')
  .refine(
    (val) => {
      if (!val) return true;
      try {
        JSON.parse(val);
        return true;
      } catch {
        return false;
      }
    },
    { message: '基础数据必须为合法JSON格式' },
  )
  .optional();

// 创建应用表单 schema（基础字段，Phase 3a）
export const createAppSchema = z.object({
  name: appNameSchema,
  description: appDescriptionSchema,
  operation_mode: operationModeSchema.optional(),
  announcement: announcementSchema,
  base_data: baseDataSchema,
});

export type CreateAppFormValues = z.infer<typeof createAppSchema>;
